import React, { useState, useEffect } from 'react';
import { db } from '../firebase';
import { collection, onSnapshot, addDoc, updateDoc, doc, serverTimestamp } from 'firebase/firestore';

const ProjectManager = () => {
    const [projeler, setProjeler] = useState([]);
    const [yeniProje, setYeniProje] = useState({
        ad: "", baslangic: "", bitis: "", durum: "planlaniyor", hedef: "", aciklama: ""
    });

    useEffect(() => {
        const unsub = onSnapshot(collection(db, "projeler"), (snap) => {
            setProjeler(snap.docs.map(doc => ({ id: doc.id, ...doc.data() })));
        });
        return () => unsub();
    }, []);

    const projeOlustur = async () => {
        if (!yeniProje.ad) return alert("Proje adı boş bırakılamaz!");
        await addDoc(collection(db, "projeler"), {
            ...yeniProje,
            olusturmaTarihi: serverTimestamp()
        });
        setYeniProje({ ad: "", baslangic: "", bitis: "", durum: "planlaniyor", hedef: "", aciklama: "" });
    };

    return (
        <div className="flex flex-col gap-8 p-2">
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
                
                {/* SOL PANEL: YENİ PROJE AÇ */}
                <div className="bg-slate-900 p-8 rounded-[2.5rem] border border-slate-800 shadow-2xl h-fit">
                    <h2 className="text-2xl font-black text-blue-500 mb-6 uppercase italic tracking-tighter">Yeni Proje Tanımla</h2>
                    
                    <div className="flex flex-col gap-4">
                        <input 
                            placeholder="Proje Adı (Örn: 2026 Hasat)" 
                            className="bg-slate-950 border border-slate-800 p-4 rounded-2xl outline-none focus:border-blue-500 font-bold"
                            value={yeniProje.ad}
                            onChange={(e) => setYeniProje({...yeniProje, ad: e.target.value})}
                        />

                        <div className="grid grid-cols-2 gap-3">
                            <div>
                                <label className="text-[10px] font-black text-slate-500 ml-2 uppercase">Başlangıç</label>
                                <input type="date" className="w-full bg-slate-950 border border-slate-800 p-3 rounded-xl outline-none text-xs" 
                                    onChange={(e) => setYeniProje({...yeniProje, baslangic: e.target.value})}/>
                            </div>
                            <div>
                                <label className="text-[10px] font-black text-slate-500 ml-2 uppercase">Bitiş (Planlanan)</label>
                                <input type="date" className="w-full bg-slate-950 border border-slate-800 p-3 rounded-xl outline-none text-xs"
                                    onChange={(e) => setYeniProje({...yeniProje, bitis: e.target.value})}/>
                            </div>
                        </div>

                        <select 
                            className="bg-slate-950 border border-slate-800 p-4 rounded-2xl outline-none font-bold text-blue-400"
                            onChange={(e) => setYeniProje({...yeniProje, durum: e.target.value})}
                        >
                            <option value="planlaniyor">🗓️ Planlanıyor</option>
                            <option value="aktif">🟢 Aktif / Devam Ediyor</option>
                            <option value="tamamlandi">✅ Tamamlandı</option>
                        </select>

                        <textarea 
                            placeholder="Amaç ve Hedefler..." 
                            className="bg-slate-950 border border-slate-800 p-4 rounded-2xl outline-none h-24 text-sm font-semibold"
                            onChange={(e) => setYeniProje({...yeniProje, hedef: e.target.value})}
                        ></textarea>

                        <button 
                            onClick={projeOlustur}
                            className="bg-blue-600 hover:bg-blue-500 py-4 rounded-2xl font-black text-xs uppercase transition-all shadow-xl shadow-blue-900/20"
                        >
                            Projeyi Başlat
                        </button>
                    </div>
                </div>

                {/* SAĞ PANEL: MEVCUT PROJELER */}
                <div className="lg:col-span-2 grid grid-cols-1 md:grid-cols-2 gap-4 h-fit">
                    {projeler.map(p => (
                        <div key={p.id} className="bg-slate-900 border border-slate-800 p-6 rounded-[2rem] hover:border-slate-600 transition-all group relative overflow-hidden">
                            <div className={`absolute top-0 right-0 p-4 text-[10px] font-black uppercase italic ${p.durum === 'aktif' ? 'text-emerald-500' : 'text-slate-500'}`}>
                                ● {p.durum}
                            </div>
                            
                            <h3 className="text-xl font-black uppercase italic mb-2 group-hover:text-blue-500 transition-colors">{p.ad}</h3>
                            <div className="flex gap-4 mb-4">
                                <div className="text-[10px] text-slate-500 font-bold uppercase tracking-widest">
                                    📅 {p.baslangic || "???"} / {p.bitis || "???"}
                                </div>
                            </div>

                            <div className="bg-slate-950/50 p-4 rounded-xl border border-slate-800/50 mb-4">
                                <p className="text-[9px] font-black text-blue-500 uppercase mb-1">Hedef & Vizyon</p>
                                <p className="text-xs text-slate-400 italic line-clamp-2">{p.hedef || "Hedef belirtilmemiş."}</p>
                            </div>

                            <div className="flex justify-between items-center mt-auto">
                                <span className="text-[10px] font-black text-slate-600">MASRAF: <span className="text-red-500">₺0.00</span></span>
                                <button className="text-[10px] font-black text-blue-400 hover:underline uppercase italic">Detaylı Rapor →</button>
                            </div>
                        </div>
                    ))}
                </div>

            </div>
        </div>
    );
};

export default ProjectManager;